import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { useEffect } from "react";
import {
  AboutMeta,
  ContactMeta,
  FilmsMeta,
  HomeMeta,
  InternationalMeta,
  PortfolioMeta,
} from "./components/MetaTags";
import AuthenticStories from "./pages/AuthenticStories";
import InternationalShoot from "./pages/InternationalShoot";
import ArtAndCreativity from "./pages/ArtAndCreativity";
import Home from "./pages/Home";
import About from "./pages/About";
import Photography from "./pages/Photography";
import Films from "./components/Films";
import Authenticity from "./pages/Authenticity";
import Weddings from "./pages/Weddings";
import Heritage from "./pages/Heritage";
import Legacy from "./pages/Legacy";
import Rituals from "./pages/Rituals";
import Dubai from "./pages/Dubai";
import Reception from "./pages/Reception";
import Preweddings from "./pages/Preweddings";
import Contact from "./pages/Contact";
import CancellationAndRefund from "./pages/CancellationAndRefund";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTopOnRouteChange />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <HomeMeta />
              <Home />
            </>
          }
        />

        <Route
          path="/about"
          element={
            <>
              <AboutMeta />
              <About />
            </>
          }
        />
        <Route
          path="/photography"
          element={
            <>
              <PortfolioMeta />
              <Photography />
            </>
          }
        />
        <Route
          path="/films"
          element={
            <>
              <FilmsMeta />
              <Films />
            </>
          }
        />
        <Route
          path="/authentic-x-love-stories"
          element={
            <>
              <AuthenticStories />
            </>
          }
        />
        <Route
          path="/authenticity-meets-elegance"
          element={
            <>
              <Authenticity />
            </>
          }
        />

        <Route
          path="/weddings"
          element={
            <>
              <Weddings />
            </>
          }
        />
        <Route
          path="/the-heritage-collection"
          element={
            <>
              <Heritage />
            </>
          }
        />
        <Route
          path="/the-legacy-of-culture"
          element={
            <>
              <Legacy />
            </>
          }
        />
        <Route
          path="/the-rituals-collection"
          element={
            <>
              <Rituals />
            </>
          }
        />
        <Route
          path="/international-shoots"
          element={
            <>
              <InternationalMeta />
              <InternationalShoot />
            </>
          }
        />
        <Route
          path="/dubai"
          element={
            <>
              <Dubai />
            </>
          }
        />
        <Route
          path="/vietnam"
          element={
            <>
              <Dubai />
            </>
          }
        />
        <Route
          path="/paris"
          element={
            <>
              <Dubai />
            </>
          }
        />
        <Route
          path="/thailand"
          element={
            <>
              <Dubai />
            </>
          }
        />

        <Route
          path="/concept-creativity"
          element={
            <>
              <ArtAndCreativity />
            </>
          }
        />
        <Route
          path="/receptions"
          element={
            <>
              <Reception />
            </>
          }
        />
        <Route
          path="/preweddings"
          element={
            <>
              <Preweddings />
            </>
          }
        />
        <Route
          path="/connect"
          element={
            <>
              <ContactMeta />
              <Contact />
            </>
          }
        />
        <Route
          path="/cancellation-and-refund"
          element={
            <>
              <CancellationAndRefund />
            </>
          }
        />
        <Route
          path="/terms-and-conditions"
          element={
            <>
              <TermsAndConditions />
            </>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <>
              <PrivacyPolicy />
            </>
          }
        />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
